import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetFoodCategoriesSlice = createSlice({
    name: "getFoodCategories",
    initialState,
    reducers: {
        getFoodCategoriesRequest(state) {
            state.loading = true;
        },
        getFoodCategoriesRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getFoodCategoriesRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        clearFoodCategoriesResponse(state) {
            state.response = undefined;
            state.error = undefined;
            state.loading = false;
        }
    },
});

export const {
    getFoodCategoriesRequest,
    getFoodCategoriesRequestSuccess,
    getFoodCategoriesRequestError,
    clearFoodCategoriesResponse
} = GetFoodCategoriesSlice.actions;

export default GetFoodCategoriesSlice.reducer;
